import {
defineCustomElement,
MediaPlayButtonElement
} from "vidstack/elements";

defineCustomElement(MediaPlayButtonElement);